import React, { cloneElement } from 'react';
import styles from './CellContent.module.scss';
import cn from 'classnames';
import { Tooltip } from 'antd';

const CellContent = ({
  containerClassName,
  topRowContent,
  bottomRowContent,
  isHighlighted = false,
  isWhite = false,
  contentStyle,
  icon,
  children,
  topRowTitle = '',
  bottomRowTitle = '',
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(styles.root, containerClassName, {
        [styles.highlighted]: isHighlighted,
        [styles.whited]: isWhite,
      })}
    >
      {icon && cloneElement(icon, { className: styles.icon })}
      {children ? (
        children
      ) : (
        <div
          className={styles.contentBlock}
          style={contentStyle}
        >
          <Tooltip title={topRowTitle}>
            <p className={cn(styles.content)}>{topRowContent}</p>
          </Tooltip>
          {bottomRowContent && (
            <Tooltip title={bottomRowTitle}>
              <p className={cn(styles.content)}>{bottomRowContent}</p>
            </Tooltip>
          )}
        </div>
      )}
    </div>
  );
};

export default CellContent;
